import icon from './svg/VipBadge';
import { createIconComp } from './Core/createIconComp';

export const VipBadgeIcon = createIconComp({ icon });
